import { Box, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PowerIcon from '@mui/icons-material/Power';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';
import { useTranslatedMessages } from '../hooks/useTranslatedMessages';
import appConfig from '../config/appConfig';

const HELP_AND_SUPPORT_URL = appConfig.helpAndSupportUrl;
const DEVELOPER_DASHBOARD_URL = appConfig.developerDashboardUrl;

export default function SideBottomBar({ mini }) {
  const navigate = useNavigate();
  const { navbar, isRTL } = useTranslatedMessages();
  const sideBottomBar = navbar.side_bottom_bar || {};
  const helpText = sideBottomBar.help_and_support || 'Help & Support';
  const developerText = sideBottomBar.developer_dashboard || 'Developer Dashboard';
  const settingsText = sideBottomBar.settings || 'Settings';
  const iconSpacing = isRTL ? { marginLeft: 1, marginRight: 0 } : { marginLeft: 0, marginRight: 1 };

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 1100,
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        p: 1,
      }}
    >
      <List disablePadding>
        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            href={HELP_AND_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'text.primary',
              flexDirection: mini ? 'column' : 'row',
              alignItems: 'center',
              textAlign: mini ? 'center' : 'left',
              py: mini ? 1.5 : 1,
              '&:hover': { backgroundColor: 'action.hover' },
              borderRadius: 2,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: mini ? 'auto' : 36,
                justifyContent: 'center',
                mb: mini ? 0.5 : 0,
                color: 'text.secondary',
                paddingLeft: mini ? 2 : 0,
                paddingRight: mini ? 0 : 2,
              }}
            >
              <HelpOutlineIcon fontSize="medium" />
            </ListItemIcon>
            <ListItemText
              primary={helpText}
              primaryTypographyProps={{
                fontSize: mini ? 10 : 17,
                fontWeight: mini ? 500 : 400,
                textAlign: mini ? 'center' : 'left',
                paddingLeft: mini ? 1 : 0,
              }}
              sx={{ m: 0 }}
            />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            href={DEVELOPER_DASHBOARD_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'text.primary',
              flexDirection: mini ? 'column' : 'row',
              alignItems: 'center',
              textAlign: mini ? 'center' : 'left',
              py: mini ? 1.5 : 1,
              '&:hover': { backgroundColor: 'action.hover' },
              borderRadius: 2,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: mini ? 'auto' : 36,
                justifyContent: 'center',
                mb: mini ? 0.5 : 0,
                color: 'text.secondary',
                paddingLeft: mini ? 2 : 0,
                paddingRight: mini ? 0 : 2,
              }}
            >
              <PowerIcon fontSize="medium" />
            </ListItemIcon>
            <ListItemText
              primary={developerText}
              primaryTypographyProps={{
                fontSize: mini ? 10 : 17,
                fontWeight: mini ? 500 : 400,
                textAlign: mini ? 'center' : 'left',
                paddingLeft: mini ? 1 : 0,
              }}
              sx={{ m: 0 }}
            />
            <OpenInNewIcon
              sx={{
                fontSize: 16,
                color: 'text.secondary',
                ml: 1,
                display: mini ? 'none' : 'block',
              }}
            />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            onClick={() => navigate('/settings')}
            sx={{
              color: 'text.primary',
              flexDirection: mini ? 'column' : 'row',
              alignItems: 'center',
              textAlign: mini ? 'center' : 'left',
              py: mini ? 1.5 : 1,
              '&:hover': { backgroundColor: 'action.hover' },
              borderRadius: 2,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: mini ? 'auto' : 36,
                justifyContent: 'center',
                mb: mini ? 0.5 : 0,
                color: 'text.secondary',
                paddingLeft: mini ? 2 : 0,
                paddingRight: mini ? 0 : 2,
              }}
            >
              <SettingsIcon fontSize="medium" />
            </ListItemIcon>
            <ListItemText
              primary={settingsText}
              primaryTypographyProps={{
                fontSize: mini ? 10 : 17,
                fontWeight: mini ? 500 : 400,
                textAlign: mini ? 'center' : 'left',
                paddingLeft: mini ? 1 : 0,
              }}
              sx={{ m: 0 }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
}
